import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Avatar from './Avatar';

const Header = ({
  handleLogout,
  showNotesButton = false,
  onNotesClick,
  leftActionButton = null
}) => {
  const [isAvatarExpanded, setIsAvatarExpanded] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  const handleAvatarClick = (isAvatarExpanded, setIsAvatarExpanded) => {
    const isTransitioning = document.querySelector('.page-transition-enter-active') || 
                           document.querySelector('.page-transition-exit-active');
    if (isTransitioning) {
      return;
    }

    if (isAvatarExpanded) {
      const menuContainer = document.querySelector('.menu-container');
      menuContainer.style.animation = 'smoothClose 0.5s cubic-bezier(0.33, 1, 0.68, 1) forwards';
      setTimeout(() => {
        setIsAvatarExpanded(false);
      }, 500);
    } else {
      setIsAvatarExpanded(true);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const response = await fetch('/api/employee/profile', {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) throw new Error('Erreur lors de la récupération du profil');

      const data = await response.json();
      setUserProfile(data);
    } catch (error) {
      console.error('Erreur profil:', error);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <>
      {leftActionButton || (showNotesButton && (
        <button
          className="home-notes-button"
          onClick={onNotesClick}
          aria-label="Mes notes de frais"
          title="Mes notes de frais"
        >
          <i className="fa-solid fa-clipboard-list"></i>
        </button>
      ))}

      <Avatar 
        className={`avatar-button ${isAvatarExpanded ? 'expanded' : ''}`}
        style={{ color: "#cfcfcf" }} 
        onClick={() => handleAvatarClick(isAvatarExpanded, setIsAvatarExpanded)}
      />
      {isAvatarExpanded && createPortal(
        <div 
          className="menu-container open"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              handleAvatarClick(isAvatarExpanded, setIsAvatarExpanded);
            }
          }}
        >
          <div className="menu-content" onClick={(e) => e.stopPropagation()}>
            <h2>Profil</h2>
            {userProfile ? (
              <>
                <div className="user-info" onClick={(e) => e.stopPropagation()}>
                  <p><strong>Nom :</strong> <span>{userProfile.prenom} {userProfile.nom}</span></p>
                  <p><strong>Email :</strong> <span>{userProfile.email}</span></p>
                  {userProfile.puissanceVoiture && (
                    <p><strong>Véhicule :</strong> <span>{userProfile.puissanceVoiture}</span></p>
                  )}
                </div>
                
                <div className="user-options" onClick={(e) => e.stopPropagation()}>
                  <div className="user-options-title">Options</div>
                  <div className="user-options-placeholder">
                    Nouvelles fonctionnalités à venir...
                  </div>
                </div>
              </>
            ) : (
              <div className="user-info" onClick={(e) => e.stopPropagation()}>
                <div className="loading-profile">
                  <div className="loading-profile-spinner"></div>
                  <p>Chargement des informations...</p>
                </div>
              </div>
            )}
          </div>
          <button 
            className='buttonLogoutAM' 
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
            }}
          >
            Se déconnecter
          </button>
        </div>,
        document.body
      )}
    </>
  );
};

export default Header; 
